// Opens links to other websites in a new tab. Links within the shop,
// email and phone links, and Shopify checkout/account links open normally.
(function () {
  var internalHosts = [window.location.hostname, 'uvbtherapy.co.uk', 'www.uvbtherapy.co.uk'];

  function isExternal(link) {
    if (!link.href || link.hasAttribute('download')) return false;
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    var host = url.hostname;
    if (internalHosts.indexOf(host) !== -1) return false;
    if (/(^|\.)shopify\.com$/.test(host) || /(^|\.)myshopify\.com$/.test(host)) return false;
    return true;
  }

  function mark(link) {
    if (link.dataset.uvbExternal || !isExternal(link)) return;
    link.dataset.uvbExternal = 'true';
    link.setAttribute('target', '_blank');
    var rel = (link.getAttribute('rel') || '').split(/\s+/);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    link.setAttribute('rel', rel.join(' ').trim());
  }

  function markAll(root) {
    (root || document).querySelectorAll('a[href]').forEach(mark);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (link) mark(link);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markAll(); });
  } else {
    markAll();
  }
})();

/* Close the mobile menu drawer when an on-page anchor (e.g. #contact) is tapped */
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('header-drawer a[href^="#"], header-drawer a[href^="/#"]');
  if (!link) return;
  var drawer = link.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event);
  }
});

/* Close the Information Hub desktop dropdown after choosing a section */
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('header-menu a.uvb-hub-link');
  if (!link) return;
  var details = link.closest('details');
  if (details) details.removeAttribute('open');
});
